import instance from '../axios';
export const todayRevenue = async (id) => {
  const response = await instance.get(`branch-analytics/today-revenue`);
  return response.data;
};

export const getSalesTrend = async (dateFrom, dateTo, id) => {
  const response = await instance.get(`branch-analytics/sales-trend?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getDailyTrend = async (dateFrom, dateTo, id) => {
  const response = await instance.get(`branch-analytics/daily-trend?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getMostUsedFrame = async (dateFrom, dateTo, id) => {
  const response = await instance.get(`branch-analytics/most-used-frame?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getMostUsedCategoryFrame = async (dateFrom, dateTo, id) => {
  const response = await instance.get(
    `branch-analytics/most-used-category-frame?dateFrom=${dateFrom}&dateTo=${dateTo}`
  );
  return response.data;
};

export const getTransactionList = async (dateFrom, dateTo, id) => {
  const response = await instance.get(`branch-analytics/transaction-list?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getTransactionListById = async (id) => {
  const response = await instance.get(`branch-analytics/transaction-by-id?id=${id}`);
  return response.data;
};

export const reportPerDay = async (dateFrom, dateTo, id) => {
  const response = await instance.get(`branch-analytics/report-per-day?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const dailyRecap = async (dateFrom, dateTo, id) => {
  const response = await instance.get(`branch-analytics/daily-recap?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};
